/**
 * WebGL feature detection (doc 147 §8.3, doc 148 PERF-05).
 *
 * Sigma's primary renderer is WebGL. On locked-down corporate machines (and in
 * jsdom) WebGL is unavailable — the constellation view feature-detects and
 * falls back to a text view rather than rendering a blank canvas.
 */

/** True when the browser can give us a WebGL (or WebGL2) rendering context. */
export function detectWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const ctx =
      canvas.getContext('webgl2') ??
      canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl');
    return ctx !== null && ctx !== undefined;
  } catch {
    return false;
  }
}
